import type { RuleDefinition, RuleFinding } from '../domain/types';
import { finding, duplicateSignature } from './helpers';

export const BQ010: RuleDefinition = {
  id: 'BQ010',
  name: '疑似完全重复清单',
  description: '仅在同一工作表内比较编码、名称、特征、单位及三个数值字段。',
  defaultSeverity: 'warning',
  enabled: true,
  applicableFields: ['code', 'name', 'description', 'unit', 'quantity', 'unitPrice', 'amount'],
  message: '该明细与同工作表中的另一条记录完全相同。',
  suggestion: '请对照关联行人工确认是否重复录入；本工具不会自动删除记录。',
  check: ({ detailRows }) => {
    const results: RuleFinding[] = [];
    const firstBySignature = new Map<string, number>();
    [...detailRows]
      .sort((left, right) => left.excelRow - right.excelRow)
      .forEach((row) => {
        const signature = duplicateSignature(row);
        if (signature === null) return;
        const firstRow = firstBySignature.get(signature);
        if (firstRow === undefined) {
          firstBySignature.set(signature, row.excelRow);
          return;
        }
        results.push(
          finding(row, null, {
            relatedRows: [firstRow],
            message: `该明细与第 ${String(firstRow)} 行的七个核心字段完全相同。`,
          }),
        );
      });
    return results;
  },
};
